import { defineMessages } from 'react-intl';

// Central constant for size default and helpers
export const DEFAULT_SIZE = 30;

// i18n messages for the size schema field
const messages = defineMessages({
  field_size: {
    id: 'form_field_size',
    defaultMessage: 'Size',
  },
  field_size_description: {
    id: 'form_field_size_description',
    defaultMessage: 'The size of the text box, in characters.',
  },
});

export const SIZE_FIELD = 'size';

export const getSizeProperty = (intl) => ({
  title: intl.formatMessage(messages.field_size),
  description: intl.formatMessage(messages.field_size_description),
  type: 'number',
  default: DEFAULT_SIZE,
});

export default DEFAULT_SIZE;
